import { Component, EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SNItem } from '../models/snitem';

export class DrugNotification {
  constructor(
    public source: any,
    public type: DrugNotificationType,
    public item: SNItem
  ) { }

}
export enum DrugNotificationType {
  add = 0,
  remove = 1,
  select = 2,
  update = 3
}

@Injectable({
  providedIn: 'root'
})
export class DrugNotificationService {

  private emitters: EventEmitter<DrugNotification>[] = [];

  constructor() { }

  getEmitter(): EventEmitter<DrugNotification> {
    const newEmit = new EventEmitter<DrugNotification>();
    this.emitters.push(newEmit);
    return newEmit;
  }

  releaseEmitter(emitter: EventEmitter<DrugNotification>) {
    const index = this.emitters.indexOf(emitter);
    if (index !== -1) {
      this.emitters.splice(index, 1);
    }
  }

  notifyLatest(source: any, type: DrugNotificationType, item: SNItem) {
    // notify to latest emitter
    if (this.emitters.length !== 0) {
      const latestEmitter = this.emitters[this.emitters.length - 1];
      latestEmitter.emit(new DrugNotification(
        source,
        type,
        item
      ));
    }
  }
}
